import appLocaleData from 'react-intl/locale-data/fi';
import fiMessages from '../locales/fi_FI';

const FiLang = {
    messages: {
        ...fiMessages
    },
    locale: 'fi-FI',
    data: appLocaleData
};
export default FiLang;